<div class="fb-block" [class.collapsed]="isCollapsed">
  <div class="fb-block__header">
    <button class="fb-block__collapse-btn" (click)="toggleCollapse()">
      <i
        [class]="
          isCollapsed ? 'fa-solid fa-chevron-right' : 'fa-solid fa-chevron-down'
        "></i>
    </button>
    <div class="fb-block__drag-handle">
      <i class="fa-solid fa-grip-vertical"></i>
    </div>
    <irembogov-fb-inline-edit
      [value]="blockLabel"
      placeholder="Block title"
      (valueChange)="onBlockLabelChange($event)">
    </irembogov-fb-inline-edit>
    <span class="fb-block__count" *ngIf="isCollapsed">
      {{ fieldCount }} field{{ fieldCount !== 1 ? 's' : '' }}
    </span>
    <div class="fb-block__actions">
      <button
        class="fb-block__action-btn"
        title="Block settings"
        (click)="configure(); $event.stopPropagation()">
        <i class="fa-solid fa-gear"></i>
      </button>
      <button
        class="fb-block__action-btn fb-block__action-btn--danger"
        title="Delete block"
        (click)="onDeleteBlock()">
        <i class="fa-solid fa-trash"></i>
      </button>
    </div>
  </div>
  <div class="fb-block__content" *ngIf="!isCollapsed">
    <div
      [sortablejs]="fields"
      [sortablejsOptions]="sortableOptions"
      class="fb-block__fields">
      <ng-container *ngFor="let field of fields; trackBy: trackByFieldKey">
        <!-- Repeater field: renders as an expandable container with child fields -->
        <div
          *ngIf="isRepeaterField(field); else regularField"
          class="fb-repeater"
          [class.fb-repeater--selected]="isFieldSelected(field)"
          [class.fb-repeater--collapsed]="isRepeaterCollapsed(field)">
          <div class="fb-repeater__header" (click)="onFieldSelect(field)">
            <button
              class="fb-repeater__collapse-btn"
              (click)="toggleRepeaterCollapse(field); $event.stopPropagation()">
              <i
                [class]="
                  isRepeaterCollapsed(field)
                    ? 'fa-solid fa-chevron-right'
                    : 'fa-solid fa-chevron-down'
                "></i>
            </button>
            <i class="fa-solid fa-list-ol fb-repeater__icon"></i>
            <span class="fb-repeater__label">{{
              field.props?.label || field.key
            }}</span>
            <span class="fb-repeater__key">{{ field.key }}</span>
            <span class="fb-repeater__badge">Repeater</span>
            <span
              class="fb-repeater__child-count"
              *ngIf="isRepeaterCollapsed(field)">
              {{ getRepeaterFieldGroup(field).length }} field{{
                getRepeaterFieldGroup(field).length !== 1 ? 's' : ''
              }}
            </span>
            <div class="fb-repeater__actions">
              <button
                class="fb-repeater__action-btn"
                title="Duplicate"
                (click)="onFieldDuplicate(field); $event.stopPropagation()">
                <i class="fa-solid fa-copy"></i>
              </button>
              <button
                class="fb-repeater__action-btn fb-repeater__action-btn--danger"
                title="Delete"
                (click)="onFieldDelete(field); $event.stopPropagation()">
                <i class="fa-solid fa-trash"></i>
              </button>
            </div>
          </div>

          <div class="fb-repeater__content" *ngIf="!isRepeaterCollapsed(field)">
            <div class="fb-repeater__fields-header">
              <i class="fa-solid fa-layer-group"></i>
              <span
                >Fields per item ({{
                  getRepeaterFieldGroup(field).length
                }})</span
              >
            </div>
            <div
              [sortablejs]="getRepeaterFieldGroup(field)"
              [sortablejsOptions]="repeaterSortableOptions"
              class="fb-repeater__fields">
              <irembogov-fb-field-wrapper
                *ngFor="
                  let child of getRepeaterFieldGroup(field);
                  trackBy: trackByFieldKey
                "
                [field]="child"
                [isSelected]="isFieldSelected(child)"
                (selectField)="onFieldSelect($event)"
                (deleteField)="onRepeaterFieldDelete(field, $event)"
                (duplicateField)="onRepeaterFieldDuplicate(field, $event)">
              </irembogov-fb-field-wrapper>
            </div>
            <div
              class="fb-repeater__empty"
              *ngIf="getRepeaterFieldGroup(field).length === 0">
              <i class="fa-solid fa-plus-circle"></i>
              <span
                >No fields yet. Add fields to define each repeater item.</span
              >
            </div>
            <irembogov-fb-add-field-button
              (addField)="
                onRepeaterFieldAdd(field, $event)
              "></irembogov-fb-add-field-button>
          </div>
        </div>

        <!-- Regular field -->
        <ng-template #regularField>
          <irembogov-fb-field-wrapper
            [field]="field"
            [isSelected]="isFieldSelected(field)"
            (selectField)="onFieldSelect($event)"
            (deleteField)="onFieldDelete($event)"
            (duplicateField)="onFieldDuplicate($event)">
          </irembogov-fb-field-wrapper>
        </ng-template>
      </ng-container>
    </div>
    <irembogov-fb-add-field-button
      (addField)="onAddField($event)"></irembogov-fb-add-field-button>
  </div>
</div>
